import {Typography} from '@material-ui/core';
import React from 'react';

const boldMap = {
    'semi-bold': 600,
    bold: 700,
    normal: 500,
    bolder: 800,
    light: 400,
};
/**
 * @typedef {'semi-bold' | 'bold' | 'normal' | 'bolder' | 'light'} BoldType
 * @typedef {import('@material-ui/core').TypographyProps & {bold?: BoldType}} Props
 * @param {Props} props
 * */
export default function Text(props) {
    const {bold, ...rest} = props;
    return (
        <Typography
            style={{
                fontWeight: bold && boldMap[bold] || undefined,
            }}
            {...rest}
        />
    );
}




// WEBPACK FOOTER //
// ./components/text/index.js